import { Avatar } from "@mui/material";
import { makeTintedBackgroundFromColor } from "@entrilia/shared/utilities/colorHelper";
import SparklesIcon from "@entrilia/shared/icons/SparklesIcon";

interface Props {
  size: number;
}

const AgentAvatar = ({ size }: Props) => {
  return (
    <Avatar
      variant="rounded"
      sx={(t) => ({
        width: size,
        height: size,
        bgcolor: makeTintedBackgroundFromColor(t, t.palette.primary.main),
      })}
    >
      <SparklesIcon color="primary" />
    </Avatar>
  );
};

export default AgentAvatar;
